import { faCircleExclamation } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";

interface Props {
  className?: string;
  message: string;
}

export default function SystemAlert({ className, message }: Props) {
  return (
    <div
      className={clsx("system-alert", className)}
      data-spec="system-alert"
      role="alert"
    >
      <FontAwesomeIcon
        className="system-alert__icon"
        icon={faCircleExclamation}
      />
      <span className="system-alert__message">{message}</span>
    </div>
  );
}
